// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__3wLFW","card":"Cards_card__1VGZY","infected":"Cards_infected__21ok6","recovered":"Cards_recovered__1tuEC","deaths":"Cards_deaths__2poen"};